import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

import SpecialFormattedNumber from 'Components/Price/SpecialFormattedNumber';
import CartCalcReselect from 'Redux/reselects/cartcalc';

const NavCartButton = ({ showPrice, parentClick }) => {
  const cartCalc = useSelector(state => CartCalcReselect(state));

  const { items = [], total = 0 } = cartCalc;
  return (
    <Link
      to="/cart"
      className="nav-cart-btn d-flex align-items-center"
      aria-label="Cart"
      onClick={() => { parentClick(); }}
    >
      <FontAwesomeIcon icon={faCartShopping} className="mr-1" />
      <div className={`nav-badge nav-badge-${items.length}`}>
        {items.length}
      </div>

      <span
        className={
          classNames(
            { 'd-inline-block': showPrice },
            { 'd-none': !showPrice },
            'nav-cart-total',
          )
        }
      >
        <SpecialFormattedNumber
          value={total}
          style="currency" // eslint-disable-line react/style-prop-object
        />
      </span>
    </Link>
  );
};

NavCartButton.propTypes = {
  showPrice: PropTypes.bool,
  cartCalc: PropTypes.shape({}),
  parentClick: PropTypes.func,
};

NavCartButton.defaultProps = {
  showPrice: false,
  cartCalc: {
    total: 0,
    items: [],
  },
  parentClick: () => { },
};

export default NavCartButton;
